import React from 'react';

import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';
import Heading from '@marvelapp/marvel-ui/heading';
import Align from '@marvelapp/marvel-ui/align';
import LogoRow from '@marvelapp/marvel-ui/logo-row';

import logos from 'marketing-website/configs/pages/homepage/logos.js';

export default function Share() {
  return (
    <PageWrap size="l">
      <Spacing size="xl" type="padding" position="topBottom">
        <Align type="center">
          <Spacing size="l" position="bottom" type="margin">
            <Heading tag="h4" weight="semibold" size="xxxl">
              Trusted by over 1 million students and companies worldwide
            </Heading>
          </Spacing>
        </Align>
        <Spacing size="xl" position="bottom" type="margin">
          <LogoRow logos={logos} />
        </Spacing>
      </Spacing>
    </PageWrap>
  );
}



// WEBPACK FOOTER //
// ./src/pages/pop/Trust.js